document.querySelectorAll('.card-media-wrapper').forEach(function(wrapper) {
  wrapper.addEventListener('mouseenter', function() {
    const imgs = wrapper.querySelectorAll('.media img');
    if (imgs.length >= 2) imgs[1].style.opacity = '1';
  });
  wrapper.addEventListener('mouseleave', function() {
    const imgs = wrapper.querySelectorAll('.media img');
    if (imgs.length >= 2) imgs[1].style.opacity = '0';
  });
});
